import {
  CLEAR_LEADERBOARD,
  CLEAR_LEADERBOARD_FAILED,
  CLEAR_LEADERBOARD_SUCCESS,
  GET_LEADERBOARD_POINTS,
  GET_LEADERBOARD_POINTS_FAILED,
  GET_LEADERBOARD_POINTS_SUCCESS,
  GET_LEADERBOARD_USERS_LIST,
  GET_LEADERBOARD_USERS_LIST_FAILED,
  GET_LEADERBOARD_USERS_LIST_SUCCESS,
  GET_LEADERBOARD_USERS_POINTS,
  GET_LEADERBOARD_USERS_POINTS_FAILED,
  GET_LEADERBOARD_USERS_POINTS_SUCCESS,
  HIDE_RESET_LEADERBOARD_MODAL,
  RESET_LEADERBOARD_FORM,
  SHOW_RESET_LEADERBOARD_MODAL,
  UPDATE_LEADERBOARD_POINTS,
  UPDATE_LEADERBOARD_POINTS_FAILED,
  UPDATE_LEADERBOARD_POINTS_SUCCESS,
} from "./actionTypes"

export const getLeaderboardPoints = params => ({
  type: GET_LEADERBOARD_POINTS,
  payload: params,
})

export const getLeaderboardPointsSuccess = response => ({
  type: GET_LEADERBOARD_POINTS_SUCCESS,
  payload: response,
})

export const getLeaderboardPointsFailed = error => ({
  type: GET_LEADERBOARD_POINTS_FAILED,
  payload: error,
})

export const updateLeaderboardPoints = (eventId, points) => ({
  type: UPDATE_LEADERBOARD_POINTS,
  payload: { eventId, points },
})

export const updateLeaderboardPointsSuccess = response => ({
  type: UPDATE_LEADERBOARD_POINTS_SUCCESS,
  payload: response,
})

export const updateLeaderboardPointsFailed = error => ({
  type: UPDATE_LEADERBOARD_POINTS_FAILED,
  payload: error,
})

export const showResetLeaderboardModal = () => ({
  type: SHOW_RESET_LEADERBOARD_MODAL,
  payload: {},
})

export const hideResetLeaderboardModal = () => ({
  type: HIDE_RESET_LEADERBOARD_MODAL,
  payload: {},
})

export const clearLeaderboard = params => ({
  type: CLEAR_LEADERBOARD,
  payload: params,
})

export const clearLeaderboardSuccess = response => ({
  type: CLEAR_LEADERBOARD_SUCCESS,
  payload: response,
})

export const clearLeaderboardFailed = error => ({
  type: CLEAR_LEADERBOARD_FAILED,
  payload: error,
})

export const getLeaderboardUsersPoints = params => ({
  type: GET_LEADERBOARD_USERS_POINTS,
  payload: params,
})

export const getLeaderboardUsersPointsSuccess = response => ({
  type: GET_LEADERBOARD_USERS_POINTS_SUCCESS,
  payload: response,
})

export const getLeaderboardUsersPointsFailed = error => ({
  type: GET_LEADERBOARD_USERS_POINTS_FAILED,
  payload: error,
})

export const getLeaderboardUsersList = params => ({
  type: GET_LEADERBOARD_USERS_LIST,
  payload: params,
})

export const getLeaderboardUsersListSuccess = response => ({
  type: GET_LEADERBOARD_USERS_LIST_SUCCESS,
  payload: response,
})

export const getLeaderboardUsersListFailed = error => ({
  type: GET_LEADERBOARD_USERS_LIST_FAILED,
  payload: error,
})

export const resetLeaderboardForm = () => ({
  type: RESET_LEADERBOARD_FORM,
  payload: {},
})
